import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/home.css';

// Rodapé (marcação exata da proposta: 4 colunas + barra final).
// Suporte WhatsApp: número real entra no deploy (Igor); placeholder provisório.
const WHATS_NUMBER = '+55 21 99999-9999';
const WHATS_LINK = 'https://wa.me/5521999999999';

export const SiteFooter: React.FC = () => {
  return (
    <footer className="pt-[34px] pb-[20px]">
      <div className="grid grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-[26px] pb-[26px]">
        <div className="col-span-2 lg:col-span-1">
          <b className="font-display text-[19px] text-stela-lilac block mb-[10px]">Stela Guia</b>
          <p className="text-stela-muted text-[12.5px] italic leading-[1.5] max-w-[24ch]">
            Espinha reta, mente quieta, coração tranquilo.
          </p>
        </div>

        <nav aria-label="Ferramentas">
          <b className="block text-stela-lilac text-[11px] tracking-[.14em] uppercase mb-3">Ferramentas</b>
          <Link to="/chart" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Mapa Astral</Link>
          <Link to="/compatibility" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Sinastria</Link>
          <Link to="/biorritmo" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Biorritmo</Link>
          <Link to="/lunar" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Ciclo Lunar</Link>
          <Link to="/tarot" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Tarot do Dia</Link>
        </nav>

        <nav aria-label="Conteúdo">
          <b className="block text-stela-lilac text-[11px] tracking-[.14em] uppercase mb-3">Conteúdo</b>
          <Link to="/blog" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Blog</Link>
          <Link to="/faq" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Dúvidas frequentes</Link>
          <a href="#isca" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Guia grátis (PDF)</a>
          <a href="#promocoes" className="block text-stela-muted text-[13.5px] mb-[7px] hover:text-stela-lilac">Promoções & sorteios</a>
        </nav>

        <div className="rounded-[12px] px-[14px] py-3 border border-stela-line self-start" style={{ background: 'rgba(60,180,110,.08)' }}>
          <b className="block text-stela-lilac text-[11px] tracking-[.14em] uppercase mb-3">Suporte</b>
          <a href={WHATS_LINK} target="_blank" rel="noreferrer" className="inline-flex items-center gap-[7px] text-[#8FE2AE] font-semibold text-[13.5px] hover:brightness-110">
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="w-[15px] h-[15px]">
              <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 0 0 12 2zm5.3 14.2c-.2.6-1.2 1.2-1.7 1.2-.4.1-1 .1-1.6-.1a13 13 0 0 1-2-.7c-3-1.3-5-4.4-5.2-4.6-.1-.2-1.3-1.7-1.3-3.3 0-1.5.8-2.3 1-2.6.3-.3.6-.4.8-.4h.6c.2 0 .4-.1.7.5l1 2.3c0 .2.1.4 0 .5l-.4.6-.5.5c-.2.1-.3.3-.1.6.2.3.8 1.4 1.8 2.3 1.3 1.2 2.4 1.5 2.7 1.7.3.1.5.1.7-.1l1-1.2c.3-.3.5-.2.8-.1l2.3 1.1c.3.2.5.3.5.4.1.2 0 .7-.1 1.2z" />
            </svg>
            WhatsApp {WHATS_NUMBER}
          </a>
          <span className="block text-stela-muted text-[11px] mt-1.5">Seg-Sáb · 9h-21h</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-4 justify-between items-center border-t border-stela-line py-4 text-stela-muted text-xs">
        <span>© 2026 Stela Guia</span>
        <nav className="flex gap-3.5">
          <Link to="/terms" className="hover:text-stela-lilac">Termos</Link>
          <Link to="/privacy" className="hover:text-stela-lilac">Privacidade</Link>
          <Link to="/faq" className="hover:text-stela-lilac">Exclusão de dados</Link>
        </nav>
      </div>
    </footer>
  );
};